export default __webpack_public_path__ + "static/media/SeaLife_30.e4e0badf.png";